import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "./LeavingCertificate.css"; // Your CSS file
import {
  baseUrl,
  AdmissionSource_Report,
  fetchAdminSchoolId,
} from "../../Utility/constants";
import AdminHeader from "../common/AdminHeader";
import { getSchoolId } from "../../Utility/commonFunctions";
import { toast, ToastContainer } from "react-toastify";

const AdmissionSourceReport = () => {
  const [schoolId, setSchoolId] = useState("");
  const [reportData, setReportData] = useState([]);
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [streams, setStreams] = useState([]);

  const [selectedStandardId, setSelectedStandardId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedStreamId, setSelectedStreamId] = useState("");
  const [standardValue, setStandardValue] = useState('');

  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const sectionApiUrl = `${baseUrl}/api/SectionMaster/GetSectionByStandardID`;
  const streamApiUrl = `${baseUrl}/api/StreamMaster`;

  useEffect(() => {
    const fetchSchoolId = async () => {
      const id = await getSchoolId();
      if (id) {
        setSchoolId(id);
      }
    };
    fetchSchoolId();
  }, []);

  // Fetch Standards
  useEffect(() => {
    if (schoolId) {
      axios
        .get(`${standardApiUrl}?id=${schoolId}`)
        .then((res) => setStandards(res.data))
        .catch(() => console.log("Error fetching standards"));
    }
  }, [schoolId]);

  // Fetch Streams
  useEffect(() => {
    axios
      .get(streamApiUrl)
      .then((res) => setStreams(res.data))
      .catch(() => console.log("Error fetching streams"));
  }, []);

  // Fetch Sections on Standard change
  useEffect(() => {
    if (selectedStandardId) {
      axios
        .get(`${sectionApiUrl}?id=${selectedStandardId}`)
        .then((res) => setSections(res.data))
        .catch(() => console.log("Error fetching sections"));
    } else {
      setSections([]);
      setSelectedSectionId("");
    }
  }, [selectedStandardId]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/Reports?schoolId=${schoolId}&reportName=${AdmissionSource_Report}&standardId=${selectedStandardId}&sectionId=${selectedSectionId}&streamId=${selectedStreamId}`
      );
      setReportData(response.data || []);
      if(response.data.length === 0)
      {
        toast.warning("No data available.")
      }
    } catch (error) {
      console.error("Failed to fetch report data", error);
    }
  };

  const exportToExcel = () => {
    if (reportData.length === 0) {
      alert("No data available to export");
      return;
    }

    const formattedData = reportData.map((student) => ({
      "Student Name": student.StudentName,
      Gender: student.Gender,
      Standard: student.StandardName,
      Stream: student.Stream,
      Division: student.Division,
      Board: student.Board,
      "Source of Admission": student.SourceOfAdmission,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Admission Source Report");

    XLSX.writeFile(workbook, "Admission_Source_Report.xlsx");
  };


  const handleChange = (e) => {
    setSelectedStandardId(e.target.value)
    setStandardValue(e.target.options[e.target.selectedIndex].text);
  }

  return (
    <>
      <AdminHeader />
        <ToastContainer />
      <div className="mt-5 mb-5 ms-5 me-5">
        <div className="d-flex align-items-center justify-content-between">
          <div className="flex-grow-1 text-center">
            <h2 className="mb-4">Admission Source Report</h2>
            {/* Filter Section */}
            <div className="d-flex gap-4 mb-3 align-items-center">
              <select
                className="form-control"
                value={selectedStandardId}
                onChange={(e) => handleChange(e)} //setSelectedStandardId(e.target.value)}
              >
                <option value="">Select Standard</option>
                {standards.map((std) => (
                  <option key={std.id} value={std.id}>
                    {std.standardName}
                  </option>
                ))}
              </select>

              <select
                className="form-control"
                value={selectedSectionId}
                onChange={(e) => setSelectedSectionId(e.target.value)}
                disabled={!sections.length}
              >
                <option value="">Select Section</option>
                {sections.map((sec) => (
                  <option key={sec.id} value={sec.id}>
                    {sec.name}
                  </option>
                ))}
              </select>

              <select
                className="form-control"
                value={selectedStreamId}
                onChange={(e) => setSelectedStreamId(e.target.value)}
                disabled={standardValue && Number(standardValue) <= 10}
              >
                <option value="">Select Stream</option>
                {streams.map((stream) => (
                  <option key={stream.id} value={stream.id}>
                    {stream.name}
                  </option>
                ))}
              </select>

              <button className="btn btn-primary" onClick={fetchData}>
                Search
              </button>
              {/* Export Button */}
              {reportData.length > 0 && (
                <button className="btn btn-success" onClick={exportToExcel}>
                  Export
                </button>
              )}
            </div>

          </div>

        </div>

        {reportData.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="thead-dark">
                <tr>
                  <th>Student Name</th>
                  <th>Gender</th>
                  <th>Standard</th>
                  <th>Stream</th>
                  <th>Division</th>
                  <th>Board</th>
                  <th>Source of Admission</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((student, index) => (
                  <tr key={index}>
                    <td>{student.StudentName}</td>
                    <td>{student.Gender}</td>
                    <td>{student.StandardName}</td>
                    <td>{student.Stream}</td>
                    <td>{student.Division}</td>
                    <td>{student.Board}</td>
                    <td>{student.SourceOfAdmission}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
           // <p className="text-center">No data available</p> 
       ""
        )}
      </div>
    </>
  );
};

export default AdmissionSourceReport;
